// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","subcategoryMenu":"FPLX6Kuu-kyjamp3","subcategoryItem":"_34rHM_cHxAZ483Gg","subcategoryTab":"i9FVDhjZxnI6eF1n"};